type ScreenTenantUser = {
  userId?: number | string
  loginId?: string
  account?: string
}

const LEGACY_STORAGE_KEY = 'ln-web:screen-last-tenant-id'
const STORAGE_KEY_PREFIX = 'ln-web:screen-last-tenant-id:'

export function screenTenantUserScope(user?: ScreenTenantUser | null) {
  const userId = Number(user?.userId)
  if (Number.isFinite(userId) && userId > 0) return String(userId)
  return String(user?.loginId || user?.account || '').trim()
}

function scopedKey(scope: string) {
  return `${STORAGE_KEY_PREFIX}${scope}`
}

function write(storage: Storage, key: string, value: string) {
  try {
    storage.setItem(key, value)
  } catch {
    /* 隐私模式等场景忽略 */
  }
}

function read(storage: Storage, key: string) {
  try {
    return String(storage.getItem(key) || '').trim()
  } catch {
    return ''
  }
}

function remove(storage: Storage, key: string) {
  try {
    storage.removeItem(key)
  } catch {
    /* ignore */
  }
}

function removeByPrefix(storage: Storage, prefix: string) {
  try {
    const keys: string[] = []
    for (let i = 0; i < storage.length; i += 1) {
      const key = storage.key(i)
      if (key && key.startsWith(prefix)) keys.push(key)
    }
    keys.forEach((key) => storage.removeItem(key))
  } catch {
    /* ignore */
  }
}

function dropLegacyKeys() {
  remove(sessionStorage, LEGACY_STORAGE_KEY)
  remove(localStorage, LEGACY_STORAGE_KEY)
}

export function saveScreenTenantId(tenantId: string, user?: ScreenTenantUser | null) {
  const id = String(tenantId || '').trim()
  const scope = screenTenantUserScope(user)
  if (!id || !scope) return
  const key = scopedKey(scope)
  write(sessionStorage, key, id)
  write(localStorage, key, id)
  dropLegacyKeys()
}

export function loadScreenTenantId(user?: ScreenTenantUser | null) {
  const scope = screenTenantUserScope(user)
  dropLegacyKeys()
  if (!scope) return ''
  const key = scopedKey(scope)
  return read(sessionStorage, key) || read(localStorage, key)
}

/** 退出登录时清掉本账号及历史全局记住的大屏租户 */
export function clearScreenTenantMemory(user?: ScreenTenantUser | null) {
  const scope = screenTenantUserScope(user)
  dropLegacyKeys()
  if (scope) {
    remove(sessionStorage, scopedKey(scope))
    remove(localStorage, scopedKey(scope))
    return
  }
  removeByPrefix(sessionStorage, STORAGE_KEY_PREFIX)
  removeByPrefix(localStorage, STORAGE_KEY_PREFIX)
}
